<template>
  <div class="form-group">
    <h2 class="text-lg text-indigo-900 font-semibold uppercase mt-4 form-item-box">
      {{ name }}
    </h2>
    <slot/>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: 'BFormGroup',
  props: {
    name: {type: String, required: true},
  },
});
</script>
